import { getPendingFilterFields } from "../../../rewamp/components/filters/filterFieldRegistry";

export const GRM_FILTER_FIELDS = [
  { id: "category", kind: "singleSelect", labelKey: "GRM_LIST.FILTER_CATEGORY", optionsKey: "categoryOptions", clearable: true },
  {
    id: "subCategory",
    kind: "singleSelect",
    labelKey: "GRM_LIST.FILTER_SUB_CATEGORY",
    optionsKey: "subCategoryOptions",
    dependsOn: "category",
    clearable: true,
  },
  {
    id: "subSubCategory",
    kind: "singleSelect",
    labelKey: "GRM_LIST.FILTER_SUB_SUB_CATEGORY",
    optionsKey: "leafOptions",
    dependsOn: "subCategory",
    clearable: true,
  },
  { id: "dateRange", kind: "dateRange", labelKey: "GRM_LIST.FILTER_DATE", clearable: false },
];

export const EMPTY_GRM_FILTERS = { category: "", subCategory: "", subSubCategory: "", dateRange: { from: "", to: "" } };
export const EMPTY_GRM_APPLIED = { serviceCode: null, dateRange: EMPTY_GRM_FILTERS.dateRange };

// A parent change clears its children, so a stale leaf never stays selected.
export const nextGrmFilters = (filters, fieldId, value) => {
  if (fieldId === "dateRange") return { ...filters, dateRange: value ?? EMPTY_GRM_FILTERS.dateRange };
  if (fieldId === "category") return { ...EMPTY_GRM_FILTERS, dateRange: filters.dateRange, category: value ?? "" };
  if (fieldId === "subCategory") return { ...filters, subCategory: value ?? "", subSubCategory: "" };
  return { ...filters, subSubCategory: value ?? "" };
};

// A half-picked selection keeps the last applied filter, so the list doesn't jump while the user is choosing.
export const resolveGrmAppliedFilters = (filters, applied, fields = GRM_FILTER_FIELDS) => {
  if (Object.keys(getPendingFilterFields(fields, filters)).length) return applied;
  const serviceCode = filters.subSubCategory || null;
  const { from, to } = filters.dateRange;
  if (serviceCode === applied.serviceCode && from === applied.dateRange.from && to === applied.dateRange.to) return applied;
  return { serviceCode, dateRange: filters.dateRange };
};
